export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./link-back.vue?vue&type=template&id=55448a36&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/link-back/link-back.vue?vue&type=template&id=55448a36&
// module id = 1089
// module chunks = 0